import { useAccess } from "@templates/course/hooks/useAccess";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import { FESTIVAL_TYPE } from "enums/festival-type";
import { FC, useMemo } from "react";

const numberToPriceStr = (num: number) =>
  separateMoneyNumbers(toFarsiNumber(num));

const ProductSidebarPriceWithDiscount: FC = () => {
  const { courseData } = useAccess();
  const {
    product: { fara_festival: { festival_type } = {} },
  } = courseData;

  const getFestivalKindText = () => {
    switch (festival_type) {
      case FESTIVAL_TYPE.PERCENT:
        return `%${toFarsiNumber(discount_value)}`;
      case FESTIVAL_TYPE.WONDER:
        return "شگفتی";
      case FESTIVAL_TYPE.STEPPED_AMOUNT:
      case FESTIVAL_TYPE.STEPPED_COUNT:
        return discount;
      default:
        return discount;
    }
  };

  const { discount, price_after_discount, is_percent, discount_value } =
    courseData.product?.fara_festival || {};

  const { main_price, price_with_discount } = useMemo(() => {
    const price_with_discount = price_after_discount || discount;
    const main_price = courseData?.product?.price;
    if (main_price && price_with_discount) {
      if (is_percent) {
        return {
          percent: discount_value as number,
          main_price,
          price_with_discount,
        };
      } else {
        const percent = Math.ceil((price_with_discount / main_price) * 100);
        return {
          percent,
          main_price,
          price_with_discount,
        };
      }
    } else
      return {
        percent: 0,
        main_price: 0,
        price_with_discount: 0,
      };
  }, [
    courseData?.product?.price,
    discount,
    discount_value,
    is_percent,
    price_after_discount,
  ]);

  const hasDiscount = price_after_discount && main_price > price_after_discount;

  return (
    <div className="flex flex-col items-end">
      {hasDiscount && (
        <div className="flex items-center gap-1.5">
          <del className="text-fds-secondary body-lg">
            {numberToPriceStr(main_price)}
          </del>
          <div className="px-1 lg:px-1.5  h-5    lg:h-6  flex items-center justify-center bg-fds-danger text-fds-on-inverse rounded-4">
            <p className="text-sm">{getFestivalKindText()}</p>
          </div>
        </div>
      )}
      <div className="flex gap-1">
        <p className="lg:headline-md headline-sm">
          {numberToPriceStr(
            hasDiscount ? price_with_discount : courseData?.product?.price
          )}
        </p>
        <p className="lg:body-md body-sm text-fds-primary">تومان</p>
      </div>
    </div>
  );
};

export default ProductSidebarPriceWithDiscount;
